<template>
  <div id="author-submit-manuscripts-author-information">
    <div class="ipub-h2 mar-b-30 line-h-40 relative">
      Author<template v-if="(firstList.length + authorList.length)>1">s</template>({{firstList.length + authorList.length}})
    </div>
    <!-- 作者列表 -->
    <div class="mar-b-40">
      <div>
        <template v-for="(item, index) in firstList">
          <div :key="'params.firstList'+index">
            <div class="author-item ipub-p2">
              <div class="relative mar-b-20 flex">
                <template v-if="firstIndex !== index">
                  <ipub-icon v-if="index === 0"
                             type="iconMoveUp"
                             class="line-color" />
                  <a v-else
                     @click="setSort(index, -1, 'firstList')">
                    <ipub-icon type="iconMoveUp" />
                  </a>
                  <ipub-icon v-if="index === firstList.length-1"
                             class="line-color mar-l-10"
                             type="iconMoveDown" />
                  <a v-else
                     @click="setSort(index, 1, 'firstList')">
                    <ipub-icon class="mar-l-10"
                               type="iconMoveDown" />
                  </a>
                  <font class="ipub-p1 mar-l-10"
                        style="margin-right:30px"># 1 {{title[item.titleCode]}} {{item.firstName}} {{item.lastName}}</font>
                  <ipub-label v-if="item.submited"
                              size="small"
                              class="mar-l-10">Submitted Author</ipub-label>
                  <ipub-label v-if="item.firsted"
                              size="small"
                              class="mar-l-10">First Author</ipub-label>
                  <ipub-label v-if="item.corresponded"
                              size="small"
                              class="mar-l-10">Correspondence Author</ipub-label>
                </template>
                <template v-else>
                  <ipub-radio class="mar-l-40"
                              :checked="editData.firsted"
                              checkBox
                              @change="() => {editData.firsted = !editData.firsted}"
                              label="First Author" />
                  <ipub-radio :checked="editData.corresponded"
                              checkBox
                              class="mar-l-20"
                              @change="() => {editData.corresponded = !editData.corresponded}"
                              label="Correspondence Author" />
                </template>
                <div class="right-option table-actions">
                  <template v-if="firstIndex !== index">
                    <ipub-icon type="iconEdit"
                               @click="edit(item, index)" />
                    <ipub-icon type="iconDelete"
                               v-if="!item.submited"
                               @click="del(item, index)" />
                  </template>
                </div>
              </div>
              <template v-if="firstIndex !== index">
                <div style="padding: 0 20px">
                  <div class="flex mar-b-12">
                    <div style="width:200px">
                      <div class="ipub-p2 fw-bd">Email</div>
                      <div class="ipub-p2">{{item.email}}</div>
                    </div>
                    <div style="width:200px">
                      <div class="ipub-p2 fw-bd">Country / Territory</div>
                      <div class="ipub-p2">{{country[item.countryCode]}}</div>
                    </div>
                    <div style="width:200px">
                      <div class="ipub-p2 fw-bd">
                        <ipub-icon class="ipub-p2"
                                   style="font-size:14px;color:#a6ce39"
                                   type="iconORCID" />
                        ORCID
                      </div>
                      <div class="ipub-p2">{{item.orcid || '--'}}</div>
                    </div>
                  </div>
                  <div>
                    <div class="ipub-p2 fw-bd">Affiliation(s)</div>
                    <div class="ipub-p2">
                      <div v-for="item in item.affiliation.split(';')"
                           :key="item">{{item}}</div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div style="padding:10px 40px 0 40px">
                  <ipub-form :ref="'author-edit-form'+index"
                             :model="editData"
                             :rules="rules">
                    <ipub-row :gutter="20">
                      <ipub-col :span="3">
                        <ipub-form-item prop="titleCode"
                                        label="Title">
                          <ipub-select v-model="editData.titleCode"
                                       placeholder="Title">
                            <ipub-select-option v-for="(value, key) in title"
                                                :key="key"
                                                :value="key">
                              {{ value }}
                            </ipub-select-option>
                          </ipub-select>
                        </ipub-form-item>
                      </ipub-col>
                      <ipub-col :span="3">
                        <ipub-form-item prop="firstName"
                                        label="First Name">
                          <ipub-input placeholder="First Name"
                                      v-model.trim="editData.firstName" />
                        </ipub-form-item>
                      </ipub-col>
                      <ipub-col :span="3">
                        <ipub-form-item prop="lastName"
                                        label="Last Name">
                          <ipub-input placeholder="Last Name"
                                      v-model.trim="editData.lastName" />
                        </ipub-form-item>
                      </ipub-col>
                      <ipub-col :span="3">
                        <ipub-form-item prop="orcid"
                                        label="ORCID">
                          <div class="ipub-p1 mar-b-10"
                               slot="label">
                            <ipub-icon class="ipub-p2"
                                       style="font-size:14px;color:#a6ce39"
                                       type="iconORCID" />
                            ORCID
                            <ipub-tooltip placement="bottomRight"
                                          type="dark">
                              <div slot="title">
                                Like 0000-0001-2345-6789 or 0000123455556789
                              </div>
                              <ipub-icon class="ipub-p1"
                                         style="font-size:14px;"
                                         type="iconInfo" />
                            </ipub-tooltip>
                          </div>
                          <ipub-input placeholder="ORCID"
                                      v-model.trim="editData.orcid" />
                        </ipub-form-item>
                      </ipub-col>
                    </ipub-row>
                    <ipub-row :gutter="20">
                      <ipub-col :span="8">
                        <ipub-form-item prop="email">
                          <div class="mar-b-10 ipub-p1"
                               slot="label">
                            Email <font class="key-color">*</font>
                            <ipub-tooltip placement="right"
                                          type="dark"
                                          class="mar-l-10">
                              <div slot="title">Please provide your institutional email address. If you do not have one, please provide a frequently used public email.</div>
                              <ipub-icon type="iconInfo" />
                            </ipub-tooltip>
                          </div>
                          <ipub-input placeholder="Email"
                                      v-model.trim="editData.email" />
                        </ipub-form-item>
                      </ipub-col>
                      <ipub-col :span="4">
                        <ipub-form-item prop="countryCode"
                                        label="Country / Territory">
                          <ipub-select v-model="editData.countryCode"
                                       search
                                       @search="countrySearch"
                                       placeholder="Country / Territory">
                            <ipub-select-option v-for="item in countryList"
                                                :value="item.code"
                                                :key="'countryList'+item.code">
                              {{item.name}} <template v-if="item.otherName">({{item.otherName}})</template>
                            </ipub-select-option>
                          </ipub-select>
                        </ipub-form-item>
                      </ipub-col>
                    </ipub-row>
                    <ipub-form-item prop="affiliation">
                      <div slot="label"
                           class="mar-b-10 ipub-p1">
                        Affiliations <font class="key-color">*</font>
                        <a @click="addAff"
                           class="ipub-p2 mar-l-10 link-color">
                          <ipub-icon type="iconAdd" /> Add New Affiliations
                        </a>
                      </div>
                      <div v-for="(item, index) in editData.affiliations"
                           class="mar-b-10"
                           :key="'editData.affiliations'+index">
                        <ipub-input placeholder="Affiliations"
                                    :suffixIcon="index===0?'':'iconClose'"
                                    @blur="getAff"
                                    @iconClick="delAff(index)"
                                    v-model.trim="editData.affiliations[index]" />
                      </div>
                    </ipub-form-item>
                  </ipub-form>
                  <div class="ipub-p1 mar-b-20">
                    <ipub-button type="primary"
                                 plain
                                 style="width:150px"
                                 @click="cancel(index)">Cancel</ipub-button>
                    <ipub-button type="primary"
                                 style="width:150px"
                                 @click="save(item, index)">Save</ipub-button>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>
      </div>
      <div>
        <template v-for="(item, index) in authorList">
          <div :key="'params.authorList'+index">
            <div class="author-item ipub-p2">
              <div class="relative mar-b-20 flex">
                <template v-if="authorIndex !== index">
                  <ipub-icon v-if="index === 0"
                             type="iconMoveUp"
                             class="line-color" />
                  <a v-else
                     @click="setSort(index, -1, 'authorList')">
                    <ipub-icon type="iconMoveUp" />
                  </a>
                  <ipub-icon v-if="index === authorList.length-1"
                             class="line-color mar-l-10"
                             type="iconMoveDown" />
                  <a v-else
                     @click="setSort(index, 1, 'authorList')">
                    <ipub-icon class="mar-l-10"
                               type="iconMoveDown" />
                  </a>
                  <font class="ipub-p1 mar-l-10"
                        style="margin-right:30px"># {{index+2}} {{title[item.titleCode]}} {{item.firstName}} {{item.lastName}}</font>
                  <ipub-label v-if="item.submited"
                              size="small"
                              class="mar-l-10">Submitted Author</ipub-label>
                  <ipub-label v-if="item.firsted"
                              size="small"
                              class="mar-l-10">First Author</ipub-label>
                  <ipub-label v-if="item.corresponded"
                              size="small"
                              class="mar-l-10">Correspondence Author</ipub-label>
                </template>
                <template v-else>
                  <font class="ipub-p1 mar-l-10"># {{index+2}} Author</font>
                  <ipub-radio class="mar-l-12"
                              :checked="editData.firsted"
                              checkBox
                              @change="() => {editData.firsted = !editData.firsted}"
                              label="First Author" />
                  <ipub-radio :checked="editData.corresponded"
                              checkBox
                              class="mar-l-20"
                              @change="() => {editData.corresponded = !editData.corresponded}"
                              label="Corresponding Author" />
                </template>
                <div class="right-option table-actions">
                  <template v-if="authorIndex !== index">
                    <ipub-icon type="iconEdit"
                               @click="edit(item, index)" />
                    <ipub-icon type="iconDelete"
                               v-if="!item.submited"
                               @click="del(item, index)" />
                  </template>
                </div>
              </div>
              <template v-if="authorIndex !== index">
                <div style="padding: 0 20px">
                  <div class="flex mar-b-12">
                    <div style="width:200px">
                      <div class="ipub-p2 fw-bd">Email</div>
                      <div class="ipub-p2">{{item.email}}</div>
                    </div>
                    <div style="width:200px">
                      <div class="ipub-p2 fw-bd">Country / Territory</div>
                      <div class="ipub-p2">{{country[item.countryCode]}}</div>
                    </div>
                    <div style="width:200px">
                      <div class="ipub-p2 fw-bd">
                        <ipub-icon class="ipub-p2"
                                   style="font-size:14px;color:#a6ce39"
                                   type="iconORCID" />
                        ORCID
                      </div>
                      <div class="ipub-p2">{{item.orcid || '--'}}</div>
                    </div>
                  </div>
                  <div>
                    <div class="ipub-p2 fw-bd">Affiliation(s)</div>
                    <div class="ipub-p2">
                      <div v-for="item in item.affiliation.split(';')"
                           :key="item">{{item}}</div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div style="padding:10px 40px 0 40px">
                  <ipub-form :ref="'author-edit-form'+index"
                             :model="editData"
                             :rules="rules">
                    <ipub-row :gutter="20">
                      <ipub-col :span="3">
                        <ipub-form-item prop="titleCode"
                                        label="Title">
                          <ipub-select v-model="editData.titleCode"
                                       placeholder="Title">
                            <ipub-select-option v-for="(value, key) in title"
                                                :key="key"
                                                :value="key">
                              {{ value }}
                            </ipub-select-option>
                          </ipub-select>
                        </ipub-form-item>
                      </ipub-col>
                      <ipub-col :span="3">
                        <ipub-form-item prop="firstName"
                                        label="First Name">
                          <ipub-input placeholder="First Name"
                                      v-model.trim="editData.firstName" />
                        </ipub-form-item>
                      </ipub-col>
                      <ipub-col :span="3">
                        <ipub-form-item prop="lastName"
                                        label="Last Name">
                          <ipub-input placeholder="Last Name"
                                      v-model.trim="editData.lastName" />
                        </ipub-form-item>
                      </ipub-col>
                      <ipub-col :span="3">
                        <ipub-form-item prop="orcid"
                                        label="ORCID">
                          <div class="ipub-p1 mar-b-10"
                               slot="label">
                            <ipub-icon class="ipub-p2"
                                       style="font-size:14px;color:#a6ce39"
                                       type="iconORCID" />
                            ORCID
                            <ipub-tooltip placement="bottomRight"
                                          type="dark">
                              <div slot="title">
                                Like 0000-0001-2345-6789 or 0000123455556789
                              </div>
                              <ipub-icon class="ipub-p1"
                                         style="font-size:14px;"
                                         type="iconInfo" />
                            </ipub-tooltip>
                            <!-- ORCID -->
                          </div>
                          <ipub-input placeholder="ORCID"
                                      v-model.trim="editData.orcid" />
                        </ipub-form-item>
                      </ipub-col>
                    </ipub-row>
                    <ipub-row :gutter="20">
                      <ipub-col :span="8">
                        <ipub-form-item prop="email">
                          <div class="mar-b-10 ipub-p1"
                               slot="label">
                            Email <font class="key-color">*</font>
                            <ipub-tooltip placement="right"
                                          type="dark"
                                          class="mar-l-10">
                              <div slot="title">Please provide your institutional email address. If you do not have one, please provide a frequently used public email.</div>
                              <ipub-icon type="iconInfo" />
                            </ipub-tooltip>
                          </div>
                          <ipub-input placeholder="Email"
                                      v-model.trim="editData.email" />
                        </ipub-form-item>
                      </ipub-col>
                      <ipub-col :span="4">
                        <ipub-form-item prop="countryCode"
                                        label="Country / Territory">
                          <ipub-select v-model="editData.countryCode"
                                       search
                                       @search="countrySearch"
                                       placeholder="Country / Territory">
                            <ipub-select-option v-for="item in countryList"
                                                :value="item.code"
                                                :key="'countryList'+item.code">
                              {{item.name}} <template v-if="item.otherName">({{item.otherName}})</template>
                            </ipub-select-option>
                          </ipub-select>
                        </ipub-form-item>
                      </ipub-col>
                    </ipub-row>
                    <ipub-form-item prop="affiliation">
                      <div slot="label"
                           class="mar-b-10 ipub-p1">
                        Affiliations <font class="key-color">*</font>
                        <a @click="addAff"
                           class="ipub-p2 mar-l-10 link-color">
                          <ipub-icon type="iconAdd" /> Add New Affiliations
                        </a>
                      </div>
                      <div v-for="(item, index) in editData.affiliations"
                           class="mar-b-10"
                           :key="'editData.affiliations'+index">
                        <ipub-input placeholder="Affiliations"
                                    :suffixIcon="index===0?'':'iconClose'"
                                    @blur="getAff"
                                    @iconClick="delAff(index)"
                                    v-model.trim="editData.affiliations[index]" />
                      </div>
                    </ipub-form-item>
                  </ipub-form>
                  <div class="ipub-p1 mar-b-20">
                    <ipub-button type="primary"
                                 plain
                                 style="width:150px"
                                 @click="cancel(index)">Cancel</ipub-button>
                    <ipub-button type="primary"
                                 style="width:150px"
                                 @click="save(item, index)">Save</ipub-button>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="add-author-button">
      <div class="add-author-button-line"></div>
      <ipub-button type="primary"
                   style="width:200px;margin:0 10px"
                   @click="addNewAuthor"
                   icon="iconAdd">
        Add New Author
      </ipub-button>
      <div class="add-author-button-line"></div>
    </div>
    <div class="ipub-p2 mar-b-12">
      All authors will be informed of each step of manuscript processing including submission, revision, acceptance, rejection, etc. via email from our system or Assistant Editor.
    </div>
    <ipub-form class="ipub-p2 mar-b-40">
      <div class="flex mar-b-12">
        <ipub-radio :checked="authorconfirm"
                    @change="
              () => {
                authorconfirm = !authorconfirm
              }
            ">
          <span style="width: 80%">
            <font class="key-color">*</font>
            All listed authors meet the
            <a target="_blank"
               href="http://www.icmje.org/recommendations/browse/roles-and-responsibilities/defining-the-role-of-authors-and-contributors.html"
               class="link-color">ICMJE criteria</a>
            and all who meet the four criteria are identified as authors. We
            attest that all authors contributed significantly to the creation of
            this manuscript, each having fulfilled criteria as established by
            the ICMJE.
          </span>
        </ipub-radio>
      </div>
      <div class="flex mar-b-12">
        <ipub-radio :checked="manuscriptConfirm"
                    @change="() => {manuscriptConfirm = !manuscriptConfirm}">
          <font class="key-color">*</font>
          We confirm that the manuscript has been read and approved by all named authors.
        </ipub-radio>
      </div>
      <div class="flex mar-b-12">
        <ipub-radio :checked="orderConfirm"
                    @change="() => {orderConfirm = !orderConfirm}">
          <font class="key-color">*</font>
          We confirm that the order of authors listed in the manuscript has been approved by all named authors.
        </ipub-radio>
      </div>
    </ipub-form>
    <div>
      <ipub-button plain
                   style="width:150px"
                   @click="back"
                   type="primary">Previous</ipub-button>
      <ipub-button style="width:150px;"
                   :disabled="!authorconfirm||!manuscriptConfirm||!orderConfirm"
                   @click="submit"
                   type="primary">Save & Next</ipub-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import './main.scss';
</style>

<script>
import main from './main'
export default main
</script>
